import {createContext, useContext, useEffect, useRef, useState} from "react";
import {useDisclosure} from "@nextui-org/react";
import Cookies from "universal-cookie";
import {useParams} from "react-router-dom";
import {setTransaction} from "../API";

export const vendingContext = createContext();

export const useVending = () => {
    return useContext(vendingContext);
};

export const VendingProvider = ({children}) => {
    const initQR = {
        status: "",
        qr_express: {
            amount: 0,
            hook_alias: "",
            description: "",
            url: "",
            created_at: "",
            qr_data: ""
        },
        supported_clients: []
    };
    const [qrData, setQRData] = useState(initQR);

    const [results, setResults] = useState([]);
    const socketRef = useRef(null);

    const [data, setData] = useState([])
    const {isOpen, onOpen, onOpenChange} = useDisclosure();
    const [cart, setCart] = useState([]);
    const [status, setStatus] = useState("start");
    let {idMachine} = useParams();

    const generateSessionId = (length = 16) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let sessionId = '';
        for (let i = 0; i < length; i++) {
            sessionId += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return sessionId;
    };

    useEffect(() => {
        if (status === "showQR" && qrData.qr_express.hook_alias !== "") {
            ConnectSocket();
        }

        const cookies = new Cookies();
        const c = cookies.get("cart");
        if (c !== undefined)
            setCart(c);

    }, [qrData]);

    const OpenDialog = (item) => {
        setStatus("start");
        setData(item);
        onOpen();
    }

    function Reseting() {
        if(results.status === "AP") {

        }
        onOpenChange(false);
        setQRData(initQR)
        setStatus("nothing");
        setResults([]);
        setCart([]);
        const cookies = new Cookies();
        cookies.set("cart", []);
    }

    function ConnectSocket() {
        if (qrData) {
            if (qrData.qr_express.hook_alias === "") return;

            socketRef.current = new WebSocket(`wss://expendedora.online/ws/response/${qrData.qr_express.hook_alias}`);

            socketRef.current.onopen = () => {
               // console.log(`Conectado al servidor WebSocket ${qrData.qr_express.hook_alias}`);
            };

            socketRef.current.onmessage = (event) => {
                const data = JSON.parse(event.data);
                setResults(data);
                setStatus("result");
                socketRef.current.close();
                if (data.status === "AP") {
                    setTimeout(() => {
                        setStatus("close_door");
                        //Reseting();
                    }, 3000);
                }
            };

            socketRef.current.onerror = (error) => {
                console.error('WebSocket error:', error);
            };

            socketRef.current.onclose = (event) => {
                console.log('WebSocket cerrado:', event);
                // setIsConnected(false);
            };

        }
    }

    // eslint-disable-next-line
    async function openQR() {
        setStatus("loading");
        const res = await setTransaction(cart);
        if (res.status === "success") {
            //crear aqui la transacciones
            setQRData(res);
            setStatus("showQR");
        }
    }

    return (
        <vendingContext.Provider value={{
            data,
            setData,
            isOpen,
            onOpen,
            onOpenChange,
            OpenDialog,
            qrData,
            cart,
            setCart,
            status,
            setStatus,
            results,
            openQR,
            idMachine,
            Reseting
        }}>
            {children}
        </vendingContext.Provider>
    );
}